<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称/编码" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item label="产品类型" label-width="70px" prop="type_id">
				   <el-select v-model="queryForm.cat_id" placeholder="请选择产品类型" class="w-100">
					<el-option label="无" value=""></el-option>
					<el-option v-for="(item,index) in category" :key="index"
						:label="item | tree" 
						:value="item.id">
					</el-option>
				   </el-select>
				</el-form-item>
				<el-form-item label="采购时间" label-width="70px" prop="procure_time">
				  <el-date-picker
					v-model="queryForm.procure_time"
					type="daterange"
					value-format="yyyy-MM-dd"
					style="width: 260px;"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
				  </el-date-picker>
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="编码" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.bn }}
				  </template>
				</el-table-column>
				<el-table-column label="类型" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.cate_name }}
				  </template>
				</el-table-column>
				<el-table-column label="单价" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.price }}
				  </template>
				</el-table-column>
				<el-table-column label="数量" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.nums }}
				  </template>
				</el-table-column>
				<el-table-column label="金额" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.money }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.status === 1" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.status === 2" size="mini" type="danger">停用</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="明细" placement="top">
					  <el-button type="success" icon="el-icon-view" size="mini" circle @click="handleView(scope.row)"></el-button>		
					</el-tooltip>
					<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="warning" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip>
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'kc_cgmx',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
					cat_id:'',
					procure_time:[],
				},
				category:[],
			}
		},
		filters: {
			tree(item) {
				if (item.level == 0) {
					return item.name
				}
				let str = ''
				for (let i = 0; i < item.level; i++) {
					str += i == 0 ? '|--' : '--'
				}
				return str + ' ' +item.name;
			}
		},
		mounted() {
			this.getCategory()
		},
		methods:{
			handleView(item){
				this.$router.push({
				  path:"/cgmx_view",
				  query: {
					  id:item.id
				  }
				})
			},
			handleAdd(){
				this.$router.push({
				  path:"/cgmx_edit",
				  query: {}
				})
			},
			handleEdit(row) {
				this.$router.push({
				  path:"/cgmx_edit",
				  query: {
					  info:JSON.parse(JSON.stringify(row))
				  }
				})
			},
			viewImage(url) {
			  this.app.previeImage(url)
			},
			getCategory(){
				this.axios.get('/manage/category/tree').then(res=>{
					if(res.status){
						this.category = res.data
					}
				})
			},
		}
	}
</script>

<style>
</style>